import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../Link/Link';
import bt from '../../components/commonStyle.css';
import s from './NoDataSection.css';

const NoDataSection = (props) => {
    const { noDataTitle, noDataDesc, noDataNavBtnLink, navLinkBtnText, containerClass, notFoundImg } = props;
    return (
        <div className={cx(s.noDataSectionWrapper, containerClass)}>
            {notFoundImg && <div className={s.noDataImage}>
                <img src={notFoundImg} alt="not data found" />
            </div>}
            {noDataTitle && <p className={s.noDataTitleText}>{noDataTitle}</p>}
            {noDataDesc && <p className={s.noDataDescText}>{noDataDesc}</p>}
            {noDataNavBtnLink && <Link to={noDataNavBtnLink} className={bt.btnPrimary}>
                {navLinkBtnText}
            </Link>}
        </div>
    )
}

export default withStyles(bt, s)(NoDataSection);
